import { _ as _assign } from './tslib.es6-c6da0ae6.js';
import { BackgroundColors, ControlBorderColors, PositiveColors, PrimaryColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';
import { createUseStyles } from 'react-jss';
import { scrollbar } from '@picsart/design-system/foundation/styleHelpers';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { FontWeights } from '@picsart/design-system/foundation/fonts';

var useStyles$1 = createUseStyles({
  PopupContainer: {
    position: 'relative',
    height: 526,
    '@media screen and (max-width: 600px)': {
      height: 450
    }
  },
  PopupContainerEmpty: {
    position: 'relative'
  },
  brazePopup: _assign(_assign({
    position: 'fixed',
    inset: 'inherit',
    width: 340,
    height: 484,
    right: Spacings.s48,
    bottom: Spacings.s12,
    left: 'auto',
    top: 'auto',
    border: "2px solid ".concat(BackgroundColors.tint3),
    backgroundColor: BackgroundColors.base,
    borderRadius: CornerRadius.r8,
    overflowX: 'hidden',
    zIndex: 10
  }, scrollbar({
    width: 14,
    height: 14,
    trackSpacing: Spacings.s24,
    thumbProps: {
      backgroundClip: 'content-box',
      border: '5px solid transparent',
      backgroundColor: ControlBorderColors["default"],
      borderRadius: CornerRadius.r4
    },
    trackProps: {
      marginBlock: Spacings.s16
    }
  })), {
    '@media screen and (max-width: 600px)': {
      width: 314,
      height: 410,
      right: Spacings.s2
    }
  }),
  popupHeader: {
    width: 340,
    zIndex: 3,
    position: 'fixed',
    transform: 'translateY(-2px)',
    border: "2px solid ".concat(BackgroundColors.tint3),
    borderBottom: 'none',
    display: 'block',
    marginLeft: '-2px',
    background: PositiveColors.base["default"],
    boxShadow: '0px 1px 2px rgb(0 0 0 / 16%)',
    borderRadius: [CornerRadius.r8, CornerRadius.r8, CornerRadius.r0, CornerRadius.r0],
    padding: [Spacings.s8, Spacings.s16],
    '&>button': {
      height: 24,
      width: 24,
      '&:hover': {
        backgroundColor: PositiveColors.base["default"]
      }
    },
    '@media screen and (max-width: 600px)': {
      width: 314
    }
  },
  closePopup: {
    position: 'absolute',
    top: 10,
    right: Spacings.s12
  },
  brazeStart: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: FontWeights.bold,
    fontSize: FontSizes.s20,
    lineHeight: LineHeights.l28,
    '& span': {
      paddingTop: Spacings.s2,
      fontSize: FontSizes.s10,
      borderRadius: CornerRadius.circle,
      backgroundColor: PrimaryColors.base["default"],
      color: PrimaryColors.text["default"],
      marginLeft: Spacings.s12,
      marginBottom: Spacings.s2,
      textAlign: 'center',
      minWidth: 18,
      height: 18,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      aspectRatio: 1,
      fontWeight: FontWeights.medium
    }
  },
  brazeContentWrapper: {
    position: 'relative',
    top: Spacings.s64,
    padding: [Spacings.s0, Spacings.s6, Spacings.s2, Spacings.s16],
    '@media screen and (max-width: 600px)': {
      padding: [Spacings.s0, Spacings.s16, Spacings.s2, Spacings.s16]
    }
  },
  brazeContentBlock: {
    borderRadius: CornerRadius.r8,
    border: "2px solid ".concat(BackgroundColors.tint3),
    overflow: 'hidden',
    marginBottom: Spacings.s16
  },
  brazeContentImage: {
    '& img': {
      maxWidth: '100%',
      height: 'auto',
      display: 'block'
    }
  },
  cardClassicTemplate: {
    display: 'flex',
    backgroundColor: BackgroundColors.tint2,
    '& img': {
      margin: Spacings.s12,
      minWidth: 60,
      maxWidth: 60
    },
    '& h4': {
      fontSize: FontSizes.s16
    }
  },
  CardBannerTemplate: {
    '& img': {
      maxWidth: 300,
      display: 'block'
    },
    '& a': {
      display: 'block'
    }
  },
  CardDefaultTemplate: {
    display: 'block',
    minHeight: 302
  },
  brazeContent: {
    backgroundColor: BackgroundColors.tint2,
    padding: Spacings.s12,
    '& h4': {
      color: TextColors.base,
      fontWeight: FontWeights.semibold,
      marginBottom: Spacings.s4
    },
    '& p': {
      fontSize: FontSizes.s12,
      fontWeight: FontWeights.medium,
      lineHeight: LineHeights.l16,
      color: TextColors.tint1
    },
    '& a': {
      display: 'inline-block',
      marginTop: 16,
      color: PrimaryColors.base["default"],
      fontSize: FontSizes.s12,
      lineHeight: LineHeights.l16,
      fontWeight: FontWeights.semibold
    }
  },
  line: {
    width: '100%',
    height: 4,
    border: "1px solid ".concat(PrimaryColors.base["default"]),
    backgroundColor: PrimaryColors.base["default"]
  },
  cardEmpty: {
    height: 480,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: [Spacings.s0, Spacings.s32],
    '@media screen and (max-width: 600px)': {
      width: 310,
      height: 400
    },
    '& div': {
      width: 48,
      height: 48,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginBottom: Spacings.s24,
      marginTop: Spacings.s24,
      backgroundColor: BackgroundColors.tint2,
      borderRadius: CornerRadius.circle
    },
    '& p': {
      fontSize: FontSizes.s14,
      color: TextColors.tint1
    }
  }
}, {
  name: 'braze-content-cards-popup'
});

var _a;
var useStyles = createUseStyles({
  main: {
    position: 'relative',
    marginRight: Spacings.s32,
    display: 'inline-block',
    '@media screen and (max-width: 500px)': {
      marginRight: Spacings.s12,
      marginLeft: Spacings.s0
    }
  },
  brazeImageWrapper: {
    position: 'relative',
    cursor: 'pointer',
    '& img': {
      width: 24,
      height: 24
    },
    '& span': {
      position: 'absolute',
      backgroundColor: (_a = PrimaryColors.alpha) === null || _a === void 0 ? void 0 : _a.alpha20,
      border: "1px solid ".concat(PrimaryColors.text["default"]),
      width: 9,
      height: 9,
      right: 14,
      top: Spacings.s12,
      borderRadius: CornerRadius.circle,
      '@media screen and (max-width: 500px)': {
        width: 7,
        height: 7
      }
    }
  }
}, {
  name: 'braze-content-cards'
});

export { useStyles as a, useStyles$1 as u };
//# sourceMappingURL=styles-92b38f47.js.map
